import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams, ResponseContentType } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportesPromotoresService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService
  ) {
    this.service_url = this.constantsService.apiURL + '/reportes/promotores';
  }

  public getReporteGeneral(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.tipoCredito){
      myParams.append('tipo_credito', filters.tipoCredito);
    }

    if(filters.promotor){
        myParams.append('promotor', filters.promotor);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/general';
    
    return this.http.get(serviceUrl , myoptions);
  }

  public exportReporteGeneralToExcel(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.promotor){
        myParams.append('promotor', filters.promotor);
    }

    if(filters.fechaFin){
        myParams.append('fecha-fin', filters.fechaFin);
    }

    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.service_url + '/general/export';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/reportes/reportes-promotores.service.ts